var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.presenterNotification && !_vm.isWhiteLabel)?_c('BaseNotification',{staticClass:"aha-public-announcement",class:[
    ("critical-" + (_vm.presenterNotification && _vm.presenterNotification.criticalLevel)),
    {
      '--fixed': _vm.isFixed,
    } ],attrs:{"showCloseButton":true,"showActions":false,"loading":_vm.isLoadingConfiguration,"zIndex":-_vm.zIndex}},[_c('div',{domProps:{"innerHTML":_vm._f("sanitize")(_vm.presenterNotification.content,true, false)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }